export function isValidSequenceId(id) {
  return Boolean(id && id !== "new" && /^[a-f\d]{24}$/i.test(id));
}

export function sequenceDetailPath(id, section = "") {
  if (!id || id === "new") return "/app/sequences/new";
  const base = `/app/sequences/${id}`;
  if (!section || section === "editor") return base;
  return `${base}/${section}`;
}

export const TRIGGER_TYPE_OPTIONS = [
  { value: "form_submit", label: "Form submitted" },
  { value: "doi_confirmed", label: "Double opt-in confirmed" },
  { value: "tag_added", label: "Tag added" },
  {
    value: "segment_entered",
    label: "Contact enters a segment (coming soon)",
    disabled: true,
  },
];

export const DELAY_UNIT_OPTIONS = [
  { value: "minutes", label: "minutes" },
  { value: "hours", label: "hours" },
  { value: "days", label: "days" },
];

export const ENROLLMENT_STATUS_COLORS = {
  active: "blue",
  completed: "green",
  exited: "default",
  paused_quota: "orange",
};

export function emptyStep(order) {
  return {
    order,
    templateRef: null,
    subject: "",
    html: "",
    delay: { value: order === 0 ? 0 : 1, unit: "days" },
    sendWindow: null,
  };
}
